export const BASE_PALLETS_PRICING_PER_ADDRESS_DATA_INDEX = 0;
